export default {"src":"/_next/static/media/crossIcon.dee25f8f.svg","height":44,"width":44,"blurWidth":0,"blurHeight":0};